import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaMapMarkedAlt, FaGuitar } from "react-icons/fa";

interface WelcomeModalProps {
  onClose: () => void;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black backdrop-blur-[4px] bg-opacity-50 flex items-center justify-center z-[1002] p-4">
      <div className="bg-white border-modal backdrop-blur-xl relative rounded-modal shadow-xl max-w-3xl w-full my-4 max-h-[80vh] sm:max-h-[90vh] overflow-hidden">
        <div className="overflow-y-auto custom-scrollbar max-h-[80vh] sm:max-h-[90vh] p-4 sm:p-6 md:p-8">
          <div className="flex justify-end items-start mb-4 sm:mb-6">
            <img
              src={"/gear-purple.svg"}
              alt="Logo"
              className="h-[40px] mx-auto object-contain"
            />
            <button
              onClick={onClose}
              style={{ boxShadow: "none" }}
              className="text-gray-400 absolute hover:text-gray-600 text-xl flex-shrink-0 ml-2"
            >
              ✕
            </button>
          </div>

          <div className="space-y-4 sm:space-y-6">
            <p className="text-about-banner text-sm sm:text-[18px] max-w-[676px] mx-auto">
              {t("app.tagline")
                .split("\n")
                .map((line, index) => (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                ))}
            </p>

            <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="bg-primary/5 p-3 sm:p-6 rounded-card border border-primary/10">
                <div className="flex items-center gap-2 mb-2 sm:mb-3">
                  <img
                    src={"/icons/purple-pin.svg"}
                    alt="Logo"
                    className="h-[24px] object-contain"
                  />
                  <h3 className="font-medium text-primary text-sm sm:text-base">
                    {t("welcome.forVenues", "Per i Locali")}
                  </h3>
                </div>
                <p className="text-about-banner-small text-sm sm:text-base">
                  {t(
                    "welcome.venuesDescription",
                    "Registra il tuo locale e mostralo ai musicisti. Elenca le attrezzature disponibili, le opzioni di alloggio e altro ancora."
                  )}
                </p>
              </div>

              <div className="bg-secondary/5 p-3 sm:p-6 rounded-card border border-secondary/10">
                <div className="flex items-center gap-2 mb-2 sm:mb-3">
                  <img
                    src={"/icons/orange-pin.svg"}
                    alt="Logo"
                    className="h-[24px] object-contain"
                  />
                  <h3 className="font-medium text-secondary text-sm sm:text-base">
                    {t(
                      "welcome.forGearProviders",
                      "Per i Fornitori di Attrezzature"
                    )}
                  </h3>
                </div>
                <p className="text-about-banner-small text-sm sm:text-base">
                  {t(
                    "welcome.gearDescription",
                    "Condividi la tua attrezzatura musicale con la community. Elenca i tuoi strumenti per farli scoprire ai musicisti."
                  )}
                </p>
              </div>
            </div>

            <div className="bg-[#F9F9FA] p-3 sm:p-6 rounded-card mt-4 sm:mt-6">
              <h3 className="font-[600] mb-2 text-sm sm:text-base">
                {t("welcome.gettingStarted", "Per iniziare")}:
              </h3>
              <ol className="ml-2 list-decimal list-inside space-y-1 sm:space-y-0.5 text-black text-sm sm:text-base">
                <li>
                  {t("welcome.step1", "Clicca sul pulsante")}{" "}
                  <span className="font-[600] uppercase">
                    {t("navigation.login")}
                  </span>{" "}
                  {t(
                    "welcome.step1End",
                    "in alto a destra per creare il tuo account"
                  )}
                </li>
                <li>
                  {t("welcome.step2", "Usa")}{" "}
                  <span className="font-[600] uppercase">{t("forms.add")}</span>{" "}
                  {t(
                    "welcome.step2End",
                    "per registrare il tuo locale o elencare la tua attrezzatura"
                  )}
                </li>
              </ol>
            </div>

            <button
              onClick={onClose}
              className="w-full mt-4 sm:mt-6 bg-primary text-white py-3 rounded-pill hover:bg-primary-600 transition-all text-sm sm:text-base font-medium"
            >
              {t("welcome.getStarted")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
